import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import Grid from "@mui/material/Grid";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { Box, styled, Switch, InputAdornment } from "@mui/material";
import { useEffect } from "react";

import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";

const EditableBoolInput = ({
  inputId,
  propsInitialValue,
  editMode,
  inputMode,
  setParentValue,
}) => {
  const [value, setValue] = useState(
    propsInitialValue !== null ? propsInitialValue : false
  );
  const [initialValue, setInitialValue] = useState(
    propsInitialValue !== null ? propsInitialValue : false
  );
  const [isEditable, setIsEditable] = useState(editMode);

  // has been focused in edit mode
  const [touched, setTouched] = useState(false);

  // callback from the parent
  const handleInputChange = (e) => {
    setValue(e.target.checked);
  };

  const handleBlur = () => {
    if (value !== initialValue) {
      setTouched(true);
      setParentValue(inputId, value);
    }
  };

  return (
    <Grid container alignItems="center" spacing={1}>
      <Grid item xs>
        {editMode ? (
          <Switch
            checked={value}
            onChange={handleInputChange}
            onBlur={handleBlur}
            sx={{
              "& MuiSwitch-track": {
                opacity: 1, // to alleviate disabled effect
              },
            }}
          />
        ) : value ? (
          <DoneIcon color="success" />
        ) : (
          <CloseIcon color="error" />
        )}
      </Grid>
    </Grid>
  );
};

export default EditableBoolInput;
